module.exports = __webpack_public_path__ + "static/media/badge-header.ed7c58ea.svg";